import Plans from 'billing/containers/Plans';
import { type FC } from 'react';
import { type RouteComponentProps } from 'react-router';

interface SimDataPlanProps extends RouteComponentProps<{}, RouterQueryParams> {}

const SimDataPlan: FC<SimDataPlanProps> = (props) => <Plans {...props} />;

export default SimDataPlan;
